<app-viewer-header [title]="storyboard?.displayName" [file]="storyboard?.files[fileSelected]" type='Storyboard'>
  <div class="content">
    <span>{{fileSelected + 1}} of {{storyboard?.files?.length}}</span>
    <div class="page-control">
      <button class="btn btn-outline p-0" (click)="changeFile('previous')"><i class="icon icon-page-bkwd" aria-hidden="true"></i></button>
      <button class="btn btn-outline right p-0" (click)="changeFile('next')"><i class="icon icon-page-fwd" aria-hidden="true"></i></button>
    </div>
    <button *ngIf="currentFileIsVideo" 
      class="btn btn-sm ml-2" 
      [ngClass]="thumbnailSetConfirmed ? 'btn-success' : 'btn-outline-light'"
      (click)="setAsThumbnail()" 
      title="Set as Thumbnail">
      {{ thumbnailSetConfirmed ? '✓ Thumbnail Set!' : '★ Set as Thumbnail' }}
    </button>
    <app-asset-action
      [asset]="storyboard"
      [type]="'dropdown'"
      class="file-action">
    </app-asset-action>
  </div>
</app-viewer-header>
